var path = '/templates/projects.segments/campaign_segment_row.html';
var html = "<table class=\"table campaign-table table-bordered\"><thead><tr><th>{{ 'projectsSegments.campaignSegmentRow.id' | translate }}</th><th>{{ 'projectsSegments.campaignSegmentRow.taipu' | translate }}</th><th>{{ 'projectsSegments.campaignSegmentRow.segumento_na' | translate }}</th><th class=col-sm-6>{{ 'projectsSegments.campaignSegmentRow.setsumei' | translate }}</th></tr></thead><tbody><tr><td>{{campaign.segment.id}}</td><td><zc-campaign-segment-flag segment=campaign.segment></zc-campaign-segment-flag></td><td>{{campaign.segment.name}}</td><td>{{campaign.segment.description}}</td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.segments/campaign_segment_row.html
// module id = 1440
// module chunks = 0